import { prefersReducedMotion, yieldToMainThread } from "@theme/utilities";

class BlurAnimation extends HTMLElement {
  /** @type {IntersectionObserver | null} */
  #intersectionObserver = null;

  constructor() {
    super();
  }

  connectedCallback() {
    if (prefersReducedMotion()) return;
    this.#setIntersectionObserver();
  }

  disconnectedCallback() {
    this.#intersectionObserver?.disconnect();
  }

  #setIntersectionObserver() {
    this.#intersectionObserver = new IntersectionObserver(
      (entries) => {
        console.log(entries);
        const entry = entries[entries.length - 1];

        if (!entry) return;

        if (entry.intersectionRatio >= 0.3) {
          if (this.dataset.animationRepeat === "false") {
            this.#intersectionObserver?.unobserve(entry.target);
          }

          yieldToMainThread().then(() => {
            this.classList.add("blur-animation-visible");
          });
        } else if (
          this.dataset.animationRepeat === "true" &&
          entry.intersectionRatio < 0.3
        ) {
          this.classList.remove("blur-animation-visible");
        }
      },
      { threshold: [0, 0.3] },
    );

    this.#intersectionObserver.observe(this);
  }
}

if (!customElements.get("blur-animation")) {
  customElements.define("blur-animation", BlurAnimation);
}
